import {
  closeNormDialog,
  confirmNormDialog,
  openNormDialog,
  selectNormDialogOpen,
  selectSelectedId,
} from 'features/analysis/eegIndividualSlice'
import {useAppDispatch, useAppSelector} from 'hooks'

export default function useEegIndividualNormDialog() {
  const dispatch = useAppDispatch()

  const onOpen = (payload: number) => dispatch(openNormDialog(payload))

  const onConfirm = (payload: {eegId: number; zscore?: number}) =>
    dispatch(confirmNormDialog(payload))

  const onClose = () => dispatch(closeNormDialog())

  const isOpen = useAppSelector(selectNormDialogOpen)

  const selectedId = useAppSelector(selectSelectedId)

  return {
    open: isOpen,
    selectedId,
    onOpen,
    onConfirm,
    onClose,
  }
}
